<script>
	import ResultsTable from './ResultsTable.svelte';
  import { formatPercent } from '../utils/format.js';

    /** @type {import('../types.d').ReadableRace} */
    export let feed;
  
    $: race = feed;
    $: desc = $race.description 
    $: vote_for = $race.vote_for
    $: seat = $race.seat_number
    $: isBallotMeasure = $race.race_type == "Measure"? true: false

    let hidePrecincts = true
      /** @type {import('../types.d').Crosswalk} */
    let crosswalk;
      /** @type {boolean} */
    let face;
      /** @type {string} */
    let captionNote;
      /** @type {string} */
    let caption;
      /** @type {number | null} */
    let eevp;
    /** @type {number | null} */
    let numOfwinners;

</script>

  <ResultsTable
    {crosswalk}
    {face}
    raceId={$race.id}
    {captionNote}
    {caption}
    {eevp}
    delCandidates = ''
    {numOfwinners}
    office={$race.office}
    type={$race.race_type}
    candidates={$race.candidates}
    totalVotes={$race.total_votes}
    shouldSortCandidates={true}
    {hidePrecincts}
    precinctsReportingPercent={formatPercent(race.precincts_reporting, race.precincts_total)} />

  
  
  